export default __webpack_public_path__ + "static/media/stone-guardian--front.8a0a6413.jpg";